// removed by extract-text-webpack-plugin
module.exports = {"contentContainer":"_3AFrd_X5e4KJJ7yfLVr92M","condensedTable":"_2Vg3wf3Qc3e0XQXYxt22CK"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/patientPages/informationHistory/GeneralInfo.scss
// module id = 401
// module chunks = 0